/* eslint max-statements: 0 */

(function ($) {

  var dragging = false;
  var downX = -1;
  var downY = -1;

  var minLeft = 100;
  var minTop = 70;
  var rightMargin = 20;
  var bottomMargin = 50;
  var minHeight = 350;
  var contentCardOffset = 38;


  function onMouseDown(e) {
    downX = e.pageX - e.currentTarget.offsetLeft;
    downY = e.pageY - e.currentTarget.offsetTop;
    $('.draggable-panel').addClass('dragging').removeClass('positioned');
    dragging = true;
    return false;
  }

  function onMouseUp() {
    if (dragging) {
      $('.draggable-panel').addClass('positioned').removeClass('dragging');
      dragging = false;
      return false;
    }
  }

  function onMouseMove(e) {
    if (dragging) {
      $('.draggable-container').offset({ left: e.pageX - downX, top: e.pageY - downY });
      return false;
    }
  }

  function onClose() {
    $('.draggable-container').hide();
  }

  function setContainerHeight(container, newHeight) {
    var card = container.find('.draggable-panel');
    var content = card.find('.draggable-content');
    content.height(newHeight - contentCardOffset);
    card.height(newHeight);
  }

  function setContainerPosition() {
    var container = $('.draggable-container');
    if (container.length) {

      var left = $(window).width() - container.width() - rightMargin;
      if (left < minLeft) {
        left = minLeft;
      }

      var newHeight = $(window).height() - minTop - bottomMargin;
      if (newHeight < minHeight) {
        newHeight = minHeight;
      }

      setContainerHeight(container, newHeight);
      container.offset({ left: left, top: minTop });
    }
  }

  function onTouchStart(e) {
    downX = e.originalEvent.touches[0].pageX - e.currentTarget.offsetLeft;
    downY = e.originalEvent.touches[0].pageY - e.currentTarget.offsetTop;
    $('.draggable-panel').addClass('dragging').removeClass('positioned');
    dragging = true;
    return false;
  }

  function onTouchMove(e) {
    if (dragging) {
      $('.draggable-container').offset({
        left: e.originalEvent.touches[0].pageX - downX,
        top: e.originalEvent.touches[0].pageY - downY
      });
      return false;
    }
  }

  function onTouchEnd() {
    if (dragging) {
      $('.draggable-panel').addClass('positioned').removeClass('dragging');
      dragging = false;
      return false;
    }
  }

  $('.draggable-container').mousedown(onMouseDown);
  $('.draggable-container .close-x').click(onClose);
  $('.draggable-container').on('touchstart', onTouchStart);
  $('.draggable-container').on('touchmove', onTouchMove);
  $('.draggable-container').on('touchend', onTouchEnd);
  $('body').mouseup(onMouseUp);
  $('body').mousemove(onMouseMove);
  $(document).ready(setContainerPosition);
  $(window).resize(setContainerPosition);
  $(window).scroll(setContainerPosition);

}(jQuery));
